import { Sidebar } from "@/components/ui/sidebar";
import { useBusinesses } from "@/hooks/use-businesses";
import { useAuth } from "@/providers/auth-provider";
import { BusinessHeader } from "@/components/dashboard/business-header";
import { AnnouncementsBanner } from "@/components/announcements-banner";


interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const { isLoading: isAuthLoading } = useAuth();
  const { isLoadingBusinesses: isBusinessLoading } = useBusinesses();

  const isLoading = isAuthLoading || isBusinessLoading;

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin w-8 h-8 border-4 border-primary border-t-transparent rounded-full" aria-label="Loading" />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col md:flex-row">
      <Sidebar />
      <main className="flex-1 overflow-y-auto bg-background pt-14 md:pt-0 md:ml-64">
        <AnnouncementsBanner />
        <BusinessHeader />
        <div className="p-3 md:p-6">
          {children}
        </div>
      </main>
    </div>
  );
}
